import { CookieHelper } from "./CookieHelper";
import { GlobalData } from "./GlobalData";
import { Notification } from "./KendoHelpers";

export class StockPickList {
    protected static readonly STOCK_PICK_LIST = '#stockPickList';
    public static readonly COOKIE = 'stockPickListCookie';

    public static readonly STOCKS_TO_STUDY = 402;
    public static readonly WEEKLY_HOMEWORK = 901;

    protected gridId: string;
    protected apiUrl: string;
    protected dropDownTree!: kendo.ui.DropDownTree;
    protected dataSourceOptions!: kendo.data.DataSourceOptions;
    protected customDataSourceOptions!: kendo.data.DataSourceOptions;

    constructor(gridId: string, apiUrl: string, initIndex: number | null = null,
        customDataSourceOptions: any = null) {

        this.gridId = gridId;
        this.apiUrl = apiUrl;
        if (customDataSourceOptions) {
            this.customDataSourceOptions = customDataSourceOptions;
        }
        this.create(initIndex);
    }

    private create(initIndex: number | null = null) {
        const self = this;

        const defaultValue = initIndex ?? this.getCookie();

        this.dropDownTree = $(StockPickList.STOCK_PICK_LIST).kendoDropDownTree({
            placeholder: "Select ...",
            height: window.innerHeight - $('.navbar').innerHeight()! -
                $('#titleAndControls').innerHeight()! - 20,
            value: defaultValue,
            change: function () {
                const value = this.value();
                const valueInt = parseInt(value);
                if (!isNaN(valueInt)) {
                    self.setDataSourceOptions(valueInt);
                    const grid = $(self.gridId).data("kendoGrid");
                    if (grid) {
                        grid.setDataSource(new kendo.data.DataSource(self.dataSourceOptions));
                    }
                }
            },
            dataSource: [
                // ################### //
                // General 
                // ################### //
                {
                    text: "General", items: [
                        { value: 701, text: "GEN-ETFs" },
                    ]
                },
                // ################### //
                // Portfolios
                // ################### //
                {
                    text: "Portfolios", items: [
                        { value: 1, text: "IBDLive" },
                        { value: 2, text: "Value Line Stocks" },
                        { value: 3, text: "Leaderboard" },
                        { value: 4, text: "IPO Stocks" },
                        { value: 5, text: "Sector Rotation" },
                        { value: 6, text: "S&P500" },
                        { value: 8, text: "SwingTrader" },
                        { value: 9, text: "Value Line 1700" },
                        { value: 10, text: "Bases Forming" },
                        { value: 11, text: "BI Trader" },
                    ]
                },
                // ################### //
                // IBD Leaderboard
                // ################### //
                {
                    text: "IBD Leaderboard Website", items: [
                        { value: 101, text: "LB-Leaders NearBuyPoint" },
                        { value: 102, text: "LB-Leaders" },
                        { value: 103, text: "LB-Earnings Options" },
                        { value: 104, text: "LB-Short Sales" },
                        { value: 105, text: "LB-WatchList" },
                        { value: 106, text: "LB-Leaders All" },

                        { value: 111, text: "LB-SectorLeaders" },

                        { value: 121, text: "LB-Ibd50Top10" },
                        { value: 122, text: "LB-Ibd50" },

                        { value: 131, text: "LB-Spotlight" },

                        { value: 141, text: "LB-RecentActions" },
                    ]
                },

                // ################### //
                // IBD Website
                // ################### //
                {
                    text: "IBD Website - Website/Newspaper", items: [
                        { value: 201, text: "WEB-BigCap20" },
                        { value: 202, text: "WEB-SectorLeaders" },
                        { value: 203, text: "WEB-IpoLeaders" },
                        { value: 204, text: "WEB-Spotlight" },
                        { value: 205, text: "WEB-IncomeInvestor" },
                        { value: 206, text: "WEB-LongTermLeaders" },
                        { value: 207, text: "WEB-StocksOfTheDay" },

                        { value: 211, text: "WEB-DividendLeaders" },
                        { value: 212, text: "WEB-TechLeadersTop10" },
                        { value: 213, text: "WEB-EtfLeaders" },

                        { value: 221, text: "WEB-NewAmericaLast30" },
                        { value: 222, text: "WEB-TheNewAmerica" },
                    ]
                },

                // ################### //
                // IBD MarketSmith
                // ################### //
                {
                    text: "IBD MarketSmith - Growth250", items: [
                        { value: 301, text: "MS-Growth 250" },

                        { value: 302, text: "MS-Power From Pivot" },
                        { value: 303, text: "MS-Recent Breakouts" },
                        { value: 304, text: "MS-Breaking Out Today" },
                        { value: 305, text: "MS-Near Pivot" },
                        { value: 306, text: "MS-Tight Areas" },

                        { value: 307, text: "MS-RBO,BOT,NP" },
                        { value: 308, text: "MS-All SubLists NOT MS250" },
                    ]
                },

                // ################### //
                // IBD SwingTrader
                // ################### //
                {
                    text: "IBD SWINGTrader", items: [
                        { value: 351, text: "ST-Current Trades List" },
                    ]
                },

                // ################### //
                // Personal 
                // ################### //
                {
                    text: "Personal - Weekly Homework", items: [
                        { value: 401, text: "PER-StockSelectionGuide" },
                        {
                            value: StockPickList.STOCKS_TO_STUDY,
                            text: "PER-Stocks To Study"
                        },
                        { value: 403, text: "PER-ETFs" },
                        { value: 404, text: "PER-Watch List" },

                        { value: 411, text: "PER-MasterList" },

                        { value: 501, text: "PER-Stocks To Buy" },
                        { value: 502, text: "PER-Stocks To Sell" },
                        { value: 503, text: "PER-Stocks To BuyOrSell" },

                        { value: 601, text: "PER-Stocks Owned" },

                        { value: 901, text: "ALL-WeeklyData" },
                        { value: 902, text: "PER-QuickRanking" },
                        { value: 904, text: "PER-PivotPointUpdates" },
                    ]
                },
            ] // End: dataSource
        }).data('kendoDropDownTree')!;

        this.setDataSourceOptions(defaultValue);
    }

    public select(value: number) {
        this.dropDownTree.value(value);
        this.trigger();
    }

    public trigger() {
        this.dropDownTree.trigger('change');
    }

    public getCookie(): number {
        return CookieHelper.get(StockPickList.COOKIE);
    }

    public getDataSourceOptions() {
        return this.dataSourceOptions;
    }

    protected setDataSourceOptions(index: number): void {
        if (this.customDataSourceOptions) {
            this.dataSourceOptions = this.customDataSourceOptions;
            if (!this.dataSourceOptions.transport) {
                this.dataSourceOptions.transport = {};
            }
        } else {
            this.dataSourceOptions = {};
            this.dataSourceOptions.transport = {};
        }

        this.dataSourceOptions.transport.read = 
            GlobalData.URL_BASE + this.apiUrl + '?index=' + index;

        this.dataSourceOptions.error = (e) => {
            var notification = new Notification();
            notification.error('No data found to display');
        };

        CookieHelper.set(StockPickList.COOKIE, index);
    }
}
